module.exports = __webpack_public_path__ + "static/media/screenshot-4.b8f5d712.png";